export enum LocalEnum {
  FinanceUser = 'FinanceUser',
  updatedDevice = 'updatedDevice',
  quickBindCard = 'quickBindCard',
  // 阅读协议列表
  readContractList = 'readContractList',
}
